<template>
  <div>
    <div style="overflow: hidden;">
      <div
        style="background-image: url(https://file.lgbfss.com/www/official/images/news4.jpg); height: 713px;"
      >
        <div class="content">
          <div class="container">
            <img
              src="https://file.lgbfss.com/www/official/images/news6.png"
              alt
              style="margin: 240px -63px 0 -63px;"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻动态 -->
    <div class="Mav">
      <div class="content">
        <div class="container" style="margin: 50px 0; display: flex;">
          <div class="content-left">
            <h3 class="title text-align-center">{{ newsInfo.title }}</h3>
            <h6
              class="regin text-align-center"
            >{{ newsInfo.creater || '零工保FSS' }} | {{ newsInfo.create_time }}</h6>
            <iframe
              id="myIframe"
              @load="load($event)"
              :src="src"
              frameborder="0"
              width="100%"
              height="100%"
            ></iframe>

            <!-- <div>
              <span class="prev" @click="goPrev()">上一页</span>
              <span class="next" @click="goNext()">下一页</span>
            </div>-->
          </div>
          <div class="content-right">
            <!-- @click="goDetail(item.code)" -->
            <h5>
              <span class="split"></span> 最新文章
            </h5>

            <div v-for="(item, index) in newList" :key="index" class="article">
              <router-link
                :to="{ path: '/news_detail', query: { id: item.code } }"
                @click.native="flushCom"
              >
                <span>{{ index + 1 }}.</span>
                {{ item.title }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Nav></Nav>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Nav from '../components/nav';
import Footer from '../components/footer';
export default {
  name: 'news',
  components: {
    Nav,
    Footer,
  },
  data: () => {
    return {
      disabled: false,
      msg: 'Welcome to Use Tinymce Editor',
      newsInfo: {},
      activeIndex: 0,
      src: '',
      id: '',
      newList: [],
      pageSize: 6,
      pageNumber: 1,
    };
  },
  created () {
    this.id = this.$route.query.id;

    console.log(this.id);
    this.getDetail();
    this.getList();
  },
  methods: {
    // goDetail(id) {
    //   window.open('/news_detail?id=' + id);
    //   // this.$router.push({
    //   //   path: '/news_detail',
    //   //   query: {
    //   //     id: id,
    //   //   },
    //   // });
    // },
    flushCom () {
      this.$router.go(0);
    },
    load (event) {
      console.log(event);

      window.iFrameResize({ log: true, checkOrigin: false }, '#myIframe');
    },
    getDetail () {
      this.$axios
        .post(this.$url + '/home.news.info.json', {
          code: this.id,
        })
        .then((res) => {
          console.log(res);
          this.newsInfo = res.data.data;
          this.src = this.$url + '/home/' + this.id + '/document.html';
        })
        .catch((err) => {
          this.msg = err;
        });
    },
    getList () {
      this.$axios
        .post(this.$url + '/home.news.last.json', {
          pageSize: this.pageSize,
          pageNumber: this.pageNumber,
        })
        .then((res) => {
          console.log(res.data.data);

          this.newList = res.data.data.list;
          console.log(this.newList);
        })
        .catch((err) => {
          this.msg = err;
        });
    },
  },
};
</script>

<style lang="css" scoped>
.text-align-center {
  text-align: center;
}

.content {
  color: #333333;
  padding: 5px 0;
}

.title {
  color: #444444;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
}

.regin {
  color: #b6b6b6;
  font-size: 12px;
  margin-bottom: 15px;
}

.content-left {
  width: 100%;

  border-right: 1px solid #e6e6e6;
}

.content-right {
  width: 400px;
  padding: 0 20px;
}

.content-right h5 {
  font-size: 18px;
  padding-left: 15px;
  position: relative;
  margin-bottom: 18px;
  border-left: 3px solid #64cdff;
}

.content-right h5::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: #64cdff;
}

p {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
  margin: 20px 0;
}

.article {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666666;
  border-bottom: 1px dotted #e6e6e6;
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 6px;
  cursor: pointer;
}

.article:hover,
.prev:hover,
.next:hover {
  color: #64cdff;
}

.prev:hover,
.next:hover {
  border-color: #64cdff;
}

.prev,
.next {
  font-size: 14px;
  color: #666666;
  cursor: pointer;
  border-bottom: 1px solid #666666;
  padding-bottom: 2px;
}

.prev {
  margin-right: 50px;
}

.next {
  margin-right: 50px;
}
.Mav {
  padding: 20px;
}
.text-align {
  text-align: left;
  line-height: 32px;
  padding-bottom: 8px;
}
</style>
